/*
 * Author: Dw
 * File Created: Tuesday, 25-07-08 11:47 am
 * Last Modified: Tuesday, 25-07-08 05:34 pm, by Dw
 */

import { type FC, useEffect } from 'react';
import Image from 'next/image';
import { Box, Button, Dialog, dialogClasses } from '@mui/material';
import { Icon } from '@ucard/ds/Icon';
import type { NotificationItem } from '../../services/notification';
export interface ImageNoticeProps {
  onClick: () => void;
  open: boolean;
  onOpen?: () => void;
  onClose?: () => void;
  showClose?: boolean;
  disableBackdropClose: boolean;
  data: NotificationItem;
}
const ImageNotice: FC<ImageNoticeProps> = ({
  onClick,
  open,
  onOpen,
  onClose,
  data,
  showClose
}) => {
  useEffect(() => {
    if (open) {
      onOpen?.();
    }
  }, [open]);
  return <Dialog className="flex flex-col items-center justify-center h-full" open sx={{
    [`.${dialogClasses.paper}`]: {
      background: 'transparent',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: 'auto'
    }
  }} data-sentry-element="Dialog" data-sentry-component="ImageNotice" data-sentry-source-file="index.tsx">
      <Box sx={{
      width: '300px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column'
    }} data-sentry-element="Box" data-sentry-source-file="index.tsx">
        {/* eslint-disable-next-line @next/next/no-img-element -- ignore */}
        <img alt="decard" aria-hidden="true" onClick={() => {
        onClick();
      }} src={data.imageUrl ?? ''} style={{
        objectFit: 'cover',
        width: '300px',
        height: '400px'
      }} />
        <Box sx={{
        position: 'absolute',
        top: '344px',
        left: '50%',
        width: '260px',
        transform: 'translateX(-50%)'
      }} data-sentry-element="Box" data-sentry-source-file="index.tsx">
          <Button fullWidth onClick={() => {
          onClick();
        }} size="medium" data-sentry-element="Button" data-sentry-source-file="index.tsx">
            {data.btn}
          </Button>
        </Box>
        {showClose ? <Box sx={{
        mt: '44px',
        width: '28px',
        height: '28px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        border: '1px solid #4F5867'
      }}>
            <Icon name="Close" onClick={() => {
          onClose?.();
        }} sx={{
          fontSize: '20px'
        }} />
          </Box> : null}
      </Box>
    </Dialog>;
};
export default ImageNotice;